import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';

import { ONE_MINUTE } from '@/constants/time';
import { fetchClient } from '@/util/fetchClient';

export const diagnosisStatusValueSchema = z.enum(['New DX', 'R/R']);

export type DiagnosisStatusValue = z.infer<typeof diagnosisStatusValueSchema>;

async function getDraftsV2() {
  const { data } = await fetchClient.GET('/v2/drafts');

  return data?.data;
}

/**
 * Query options for fetching the list of drafts.
 *
 * Cache Key: ['draftsV2', userId]
 *
 * On delete:
 * 1. Update drafts list
 * 2. Invalidate drafts query
 */
export function getDraftsV2QueryOptions(userId: string | undefined) {
  return queryOptions({
    queryKey: ['draftsV2', userId],
    queryFn: () => getDraftsV2(),
    staleTime: ONE_MINUTE,
    gcTime: ONE_MINUTE,
  });
}
